import { takeLatest, put, call } from 'redux-saga/effects';
import { getListCustoFuncionarios } from '../service';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
    CONFIG_SESSION,
    CUSTO_LIST_FUNCIONARIOS,
    CUSTO_LIST_FUNCIONARIOS_PENDING,
    CUSTO_LIST_FUNCIONARIOS_SUCCESS,
    CUSTO_LIST_FUNCIONARIOS_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';

function* fetchListCustoFuncionarios(action) {
  yield put({ type: CUSTO_LIST_FUNCIONARIOS_PENDING });

  try {
    const session = JSON.parse(storage.get(CONFIG_SESSION));
    const idFazenda = session.fazendaSelecionada?.id ?? -1;
    const idSafra = session.safraAtiva?.id ?? -1;
    const dataInicial = formatDateDDMMYYYY(action.dataInicial);
    const dataFinal = formatDateDDMMYYYY(action.dataFinal);

    const dadosListCustosFuncionarios = yield call(getListCustoFuncionarios, idFazenda, idSafra, dataInicial, dataFinal);
    yield put({ type: CUSTO_LIST_FUNCIONARIOS_SUCCESS, dadosListCustosFuncionarios });
  } catch (err) {
    yield put({ type: CUSTO_LIST_FUNCIONARIOS_FAILURE });
  }
}

export default function* watchListCustoFuncionarios() {
  yield takeLatest(CUSTO_LIST_FUNCIONARIOS, fetchListCustoFuncionarios);
}
